export function parseNumber(str) {
  if (!str) return 0;

  const strValue = String(str);
  
  if (strValue.includes(',')) {
      return Number(strValue.replace(/\./g, '').replace(',', '.'));
  }
  
  return Number(strValue);
}

export default parseNumber;